import { ApproveTaskAPI } from "../api";
import { Invoice, AreaInterest, SettingTask, ContractCheckout } from ".";
import moment from 'moment'
import i18n from '@/plugins/vue-i18n';
import Vue from 'vue';
export class ApproveTask {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
    if (this.type == 'area_interest' && this.areaInterest) {
      this.areaInterest = new AreaInterest(this.areaInterest);
    } else if (this.type == 'setting' && this.settingTasks) {
      this.settingTasks = this.settingTasks.map(item => new SettingTask(item))
    }else if(this.type == 'contract_check_out' && this.contractCheckOut){
      this.contractCheckOut = new ContractCheckout(this.contractCheckOut)
    }
    if (this.appeal && this.appeal.requestData && this.appeal.requestData.installmentInvoiceObject) {
      this.appeal.requestData.installmentInvoiceObject = new Invoice(this.appeal.requestData.installmentInvoiceObject);
    }
  }
  get statusString() {
    const status = {
      pending: i18n.t('payment.wait_approval'),
      approved: i18n.t('task.approve'),
      rejected: i18n.t('task.not_approve')
    };
    return status[this.status] || "-";
  }
  get typeString() {
    const type = {
      area_interest: i18n.t('area.area_interest_quotation')
    };
    return type[this.type] || "-";
  }
  get statusColor() {
    const status = {
      pending: "text-purple-500 bg-purple-100",
      rejected: "text-pink-500 bg-pink-100",
      checking: "text-orange-500 bg-orange-100",
      rejected: "text-red-500 bg-red-100",
      waiting_contract: "text-yellow-500 bg-yellow-100",
      approved: "text-green-500 bg-green-100"
    };
    return status[this.status] || "-";
  }
  get getCustomerName() {
    if (this.type == "area_interest") return this.areaInterest.getCustomerName;
    else return "-";
  }
  get createdByFullName() {
    let res = "";
    if (this.createdBy) {
      res = `${this.createdBy.firstName} ${this.createdBy.lastName}`;
    }
    return res;
  }
  get updatedByFullName() {
    let res = "";
    if (this.createdBy) {
      res = `${this.createdBy.firstName} ${this.createdBy.lastName}`;
    }
    return res;
  }
  get createdAtDateFormat() {
    let res = "";
    if (this.createdAt) {
      res = `${moment(this.createdAt).format("DD-MM-YYYY")}`;
    }
    return res;
  }
  get updatedAtDateFormat() {
    let res = "";
    if (this.updatedAt) {
      res = `${moment(this.updatedAt).format("DD-MM-YYYY")}`;
    }
    return res;
  }
  get settingTaskAreaNames() {
    let res = ''
    for (const index in this.settingTasks) {
      let settingTask = this.settingTasks[index]
      if (settingTask) {
        res += `${settingTask.area.name || "-"}${index != this.settingTasks.length - 1 ? ', ' : ''}`
      }
    }
    return res
  }
  get settingTaskAreaCount() {
    let res = '-'
    res = this.settingTasks.length
    return res
  }
  get settingTaskSum() {
    let previous = 0, current = 0, diff = 0;
    for (const index in this.settingTasks) {
      let settingTask = this.settingTasks[index]
      if (settingTask) {
        previous += (settingTask.requestData.previousPrice ? parseFloat(settingTask.requestData.previousPrice) : 0) - (settingTask.requestData.previousOriginalDiscount ? parseFloat(settingTask.requestData.previousOriginalDiscount) : 0)
        current += (settingTask.requestData.currentPrice ? parseFloat(settingTask.requestData.currentPrice) : 0) - (settingTask.requestData.currentOriginalDiscount ? parseFloat(settingTask.requestData.currentOriginalDiscount) : 0)
      }
    }
    diff = current - previous
    return { previous, current, class: diff > 0 ? "text-green-500 bg-green-100" : diff < 0 ? "text-red-500 bg-red-100" : '', diffText: diff > 0 ? '+' + diff : diff }
  }
  get getSettingTaskAction() {
    let data = {
      add: 0,
      edit: 0,
      remove: 0
    };
    let res = "";
    if (this.settingTasks) {
      for (let index in this.settingTasks) {
        let settingTask = this.settingTasks[index];
        if (settingTask.action == "add") data.add++;
        if (settingTask.action == "edit") data.edit++;
        if (settingTask.action == "remove") data.remove++;
      }
      res = `${data.add ? `${i18n.t('add_settings')} ${data.add}` : ""}
             ${data.add && data.edit ? ',' : ''}
             ${data.edit ? `${i18n.t('edit_settings')} ${data.edit}` : ""}
             ${(data.edit && data.remove) || (data.add && data.remove) ? ',' : ''}
             ${data.remove ? `${i18n.t('delete_settings')} ${data.remove}` : ""}`;
    }
    return res;
  }

  get currencyCode() {
    if(this.settingTasks && this.settingTasks.length > 0){
      return this.settingTasks[0].currencyCode;
    }
    return Vue.prototype.$globalCurrencyCode || 'THB';
  }
  static async getApproveTasksByMarket(payload) {
    const { data } = await ApproveTaskAPI.getApproveTasksByMarket(payload);
    return data.result.map(item => new ApproveTask(item));
  }
  static async getApproveTaskSettingByMarket(payload) {
    const { data } = await ApproveTaskAPI.getApproveTaskSettingByMarket(payload);
    return data.result.map(item => new ApproveTask(item));
  }
  static async approveApproveTask(payload) {
    const { data } = await ApproveTaskAPI.approveApproveTask(payload);
    return data.result;
  }
  static async rejectApproveTask(payload) {
    const { data } = await ApproveTaskAPI.rejectApproveTask(payload);
    return data.result;
  }
}
